<template>
  <div>
    <modal-title>{{ $t('terms.rommemasters.title_rules') }}</modal-title>
    <modal-content>
      <t-text class="terms-text rules" v-html="md($t('terms.rommemasters.content_rules'))" />
    </modal-content>
  </div>
</template>

<script setup lang="ts">
import { marked } from 'marked'
function md(s: string) {
  return marked(s)
}
</script>

<style lang="less" scoped>
.terms-text {
  text-align: justify;
  &.rules {
    padding-left: 40px;
  }
}
</style>
